import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=63c8eadc&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=63c8eadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8eadc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c8eadc')) {
      api.createRecord('63c8eadc', component.options)
    } else {
      api.reload('63c8eadc', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=63c8eadc&scoped=true&", function () {
      api.rerender('63c8eadc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CiQHfR3dy72d/JS/comp/DocBox.vue"
export default component.exports